import { AnalyticsNavElementName } from "../analytics.types";

export function getCurrentNavbarSection(): AnalyticsNavElementName | null {
  const pathname = globalThis.location.pathname;

  if (pathname.startsWith("/discovery"))
    return AnalyticsNavElementName.DISCOVERY;
  if (pathname.startsWith("/gpt")) return AnalyticsNavElementName.GPT;
  if (pathname.startsWith("/foryou")) return AnalyticsNavElementName.FORYOU;
  if (pathname.startsWith("/search")) return AnalyticsNavElementName.SEARCH;
  if (pathname.startsWith("/profile")) return AnalyticsNavElementName.PROFILE;

  if (pathname.startsWith("/room/discovery"))
    return AnalyticsNavElementName.DISCOVERY;
  if (pathname.startsWith("/room/search"))
    return AnalyticsNavElementName.SEARCH;
  if (pathname.startsWith("/room/conferences"))
    return AnalyticsNavElementName.RESOURCES;
  if (pathname.startsWith("/room/resources"))
    return AnalyticsNavElementName.RESOURCES;

  return null;
}
